export const normalizeProcessProducts = (value) => {
  if (Array.isArray(value)) {
    return value.filter((code) => typeof code === "string" && code.length > 0);
  }
  if (typeof value === "string" && value.length > 0) {
    return [value];
  }
  return [];
};

export const serializeProcessProducts = (products) => {
  const normalized = normalizeProcessProducts(products);
  return normalized.length > 0 ? normalized : "";
};

export const buildProductRangeOptions = (rows, selectedProducts = []) => {
  const opts = rows.map((row) => ({
    label: row.label ? `${row.code} — ${row.label}` : row.code,
    value: row.code,
  }));

  const legacyProducts = normalizeProcessProducts(selectedProducts).filter(
    (code) => !opts.some((option) => option.value === code),
  );

  return [
    ...legacyProducts.map((code) => ({ label: code, value: code })),
    ...opts,
  ];
};
